import { getEnvironment } from 'src/environments/dinamicEnv';

const environment = getEnvironment();

export const config = {
  clientId: '', //environment.mulesoftClientId,
  clientSecret: '', //environment.mulesoftClientSecret,
};
